"use client";

import { useMemo, useState } from "react";

const SearchIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M21 21L16.65 16.65M18 10.5C18 14.6421 14.6421 18 10.5 18C6.35786 18 3 14.6421 3 10.5C3 6.35786 6.35786 3 10.5 3C14.6421 3 18 6.35786 18 10.5Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default function SidebarSearchCard({ items = [] }) {
  const [query, setQuery] = useState("");

  const filteredItems = useMemo(() => {
    const normalizedQuery = query.trim().toLowerCase();
    if (!normalizedQuery) return items;
    return items.filter((item) =>
      item.title.toLowerCase().includes(normalizedQuery)
    );
  }, [items, query]);

  return (
    <div className="overflow-hidden rounded-[24px] border border-[#bfbfbf] bg-white shadow-none">
      <div className="p-3">
        <div className="flex items-center gap-3 rounded-full border border-[#d9d9d9] bg-white px-4 py-2.5">
          <input
            value={query}
            onChange={(event) => setQuery(event.target.value)}
            placeholder="What would you like to learn?"
            className="w-full bg-transparent text-[13px] text-slate-700 outline-none placeholder:text-[#9ca3af]"
          />
          <div className="flex h-10 w-12 items-center justify-center rounded-full bg-black text-white">
            <SearchIcon />
          </div>
        </div>
      </div>

      <div className="max-h-[420px] overflow-y-auto border-t border-[#d9d9d9]">
        {filteredItems.map((item) => (
          <a
            key={item.id}
            href={`#${item.id}`}
            className="block border-b border-[#d9d9d9] px-5 py-4 text-[16px] leading-[1.35] text-[#2f2f2f] transition hover:bg-slate-50"
          >
            {item.title}
          </a>
        ))}

        {!filteredItems.length && (
          <div className="px-5 py-6 text-sm text-slate-500">
            No matching sections found.
          </div>
        )}
      </div>
    </div>
  );
}
